import { Component, OnInit } from '@angular/core';
import { InvoiceCashDeskService } from '../../../services/invoice-cash-desk/invoice-cash-desk.service';
import { InvoicePatientCashDeskService } from '../../../services/invoice-cash-desk/invoice-patient-cash-desk.service';
import { AdmissionWizardService } from '../../../services/wizard/admission/admission.wizzard.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'admission-invoice-cash-desk',
  templateUrl: './admission-invoice-cash-desk.component.html',
  styleUrls: ['./admission-invoice-cash-desk.component.css'],
  providers: [{ provide: InvoiceCashDeskService, useClass: InvoicePatientCashDeskService }]
})
export class AdmissionInvoiceCashDeskComponent implements OnInit {

  medicalOrderId: number;
  returnurl: string;
  protocol: string;
  medicalAppointmentId: number;

  constructor(private router: Router
    , private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(async (params) => {
      this.medicalOrderId =  params['MedicalOrderId'];
      this.returnurl = params['return'];
      this.protocol = params['Protocol'];
      this.medicalAppointmentId = params['MedicalAppointmentId'];
    });
  }

  close(): void {
    this.router.navigate(['admission-medical-order-scann', this.medicalOrderId
    , this.returnurl
    , this.protocol
    , this.medicalAppointmentId ]);
  }
}
